import React from 'react';

import cx from 'classnames';

import RenderInDomNode from 'components/Pages/Admin/Page/common/RenderInStuff';
import Loader from 'components/shared/Loader';
import Text from 'components/shared/Typography/Text';
import i18n from 'i18n';

import styles from './index.module.css';

export const SaveIndicator = ({ appHasChanges, mountId }) => {
  return (
    <RenderInDomNode id={mountId}>
      <div
        className={cx(
          styles.stickyLoadingIndicator,
          'custom-save-loading-indicator',
          !appHasChanges && styles.stickyLoadingIndicatorHidden,
        )}
      >
        <Text className={cx(styles.stickyLoadingIndicatorText, 'custom-save-loading-indicator-text')} accent>
          {i18n.t('proposal_content.file.saving')}
        </Text>
        <Loader width={49 / 3.7} height={52 / 3.7} />
      </div>
    </RenderInDomNode>
  );
};
